import { useCallback, useMemo } from "react";

import type { ILeadsSearchFiltersDto, LeadsSearchAllFiltersTypes } from "../types/leadsSearchFilters.dto";
import { leadsFilterDtoToPanelValue, leadsFilterPanelValueToDto } from "../utils/leadsFilterDtoAdapters";

type LeadsPanelDraftResult = [Partial<LeadsSearchAllFiltersTypes>, (next: Partial<LeadsSearchAllFiltersTypes>) => void];

/**
 * Flat panel value + update handler for a grouped leads-filter DTO held outside Redux (e.g. team draft).
 * Symmetric to `useFiltersValueState`, which reads/writes the same boundary via Redux.
 */
export const useLeadsPanelDraft = (
    dto: Partial<ILeadsSearchFiltersDto>,
    onDtoChange: (next: Partial<ILeadsSearchFiltersDto>) => void,
): LeadsPanelDraftResult => {
    const panelValue = useMemo(() => leadsFilterDtoToPanelValue(dto), [dto]);

    const handlePanelUpdate = useCallback(
        (next: Partial<LeadsSearchAllFiltersTypes>) => {
            onDtoChange(leadsFilterPanelValueToDto(next));
        },
        [onDtoChange],
    );

    return [panelValue, handlePanelUpdate];
};
